import { publicAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { PasswordFormValues } from "@/shared/models/legacy-types";

interface SetHealthiePasswordParams extends PasswordFormValues {
  token: string;
}

export const setEmbeddablesPassword = async ({
  password,
  passwordConfirmation,
  token,
}: SetHealthiePasswordParams) => {
  const { data } = await publicAPI.put<
    ServiceResponse<{ accessToken: string }>
  >("/embeddables/set-password", {
    password,
    passwordConfirmation,
    token,
  });

  return data.data;
};
